import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getAllNoticesApi } from '../../api'

export const getAllNotices = createAsyncThunk('getAllNotices', async () => {
  const { data } = await getAllNoticesApi()
  return data
})

const initialState = {
  notices: [],
  loading: false
}

export const slice = createSlice({
  name: 'notices',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllNotices.pending]: state => {
      state.loading = true
    },
    [getAllNotices.fulfilled]: (state, { payload }) => {
      state.notices = payload
      state.loading = false
    },
    [getAllNotices.rejected]: state => {
      state.loading = false
    }
  }
})
export default slice.reducer
